export const substituteDynamicIp = (link, ip) => {
    try {
        const url = new URL(link.replace(/rtsp:\/\//, 'https://'));
        url.hostname = ip;
        url.protocol = 'rtsp:';
        return url.href;
    }
    catch (e) {
        console.error(e, 'Не валидный URL');
        return link;
    }
};
